import React, { useState } from "react";
import { Modal, Box, Typography, Button, TextField, MenuItem, FormControl, FormControlLabel, Checkbox, FormGroup } from "@mui/material";

const AFFilter = ({ Filter, toggle_Filter, SendDataToParent }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedOption, setSelectedOption] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [selectedCheckboxValue, setSelectedCheckboxValue] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleCheckboxChange = (value) => {
    setSelectedCheckboxValue(selectedCheckboxValue === value ? '' : value); // Sirf ek checkbox check hoga
  };

  const SendDataToList = () => {
    SendDataToParent(fromDate, toDate, selectedOption, inputValue, selectedCheckboxValue)
  };


  return (
    <Modal
      open={Filter}
      onClose={toggle_Filter}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(1px)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <Box sx={{ position: "absolute", top: "46%", left: "52%", transform: "translate(-50%, -50%)", width: 510, bgcolor: "background.paper", p: 4, borderRadius: '8px' }}>
        <Typography id="modal-title" variant="h6" component="h2" style={{ fontWeight: 'bold', color: '#303030' }}>
          Apply Filter
        </Typography>

        <Box display="flex" justifyContent="space-between" sx={{ mt: 2 }}>
          <TextField
            label="From Date"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: '48%' }}
          />
          <TextField
            label="To Date"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: '48%' }}
          />
        </Box>

        <Box display="flex" justifyContent="space-between" sx={{ mt: 2 }}>
          <TextField
            select
            label="Select"
            value={selectedOption}
            onChange={handleSelectChange}
            sx={{ width: '34%' }}
          >
            {/* <MenuItem value="id">ID</MenuItem> */}
            <MenuItem value="name">Name</MenuItem>
            <MenuItem value="email">Email</MenuItem>
            {/* <MenuItem value="entityName">Entity Name</MenuItem> */}
            <MenuItem value="mobile">Mobile</MenuItem>
            {/* <MenuItem value="password">Password</MenuItem> */}
            {/* <MenuItem value="parentId">ParentId</MenuItem> */}
            {/* <MenuItem value="balance">Balance</MenuItem> */}
            {/* <MenuItem value="balanceCap">Balance Cap</MenuItem> */}
            {/* <MenuItem value="regDate">Reg Date</MenuItem> */}
            <MenuItem value="panNumber">Pan Number</MenuItem>
            {/* <MenuItem value="nameOnAadhaar">Name On Aadhaar</MenuItem> */}
            <MenuItem value="nameOnPan">Pan Name</MenuItem>
            {/* <MenuItem value="aadharNumber">Aadhaar Number</MenuItem> */}
            {/* <MenuItem value="aadharMask">Aadhaar Mask</MenuItem> */}
            {/* <MenuItem value="approval">Approval</MenuItem> */}
            {/* <MenuItem value="userType">User Type</MenuItem> */}
            {/* <MenuItem value="uniqueId">UniqueId</MenuItem> */}
            {/* <MenuItem value="gstNo">GST No</MenuItem> */}
            {/* <MenuItem value="tanNumber">TAN Number</MenuItem> */}
            {/* <MenuItem value="address">Address</MenuItem> */}
            {/* <MenuItem value="portId">PortId</MenuItem> */}
            {/* <MenuItem value="otp">OTP</MenuItem> */}

          </TextField>

          <TextField
            label="Input Field"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            sx={{ width: '65%' }}
          />
        </Box>

        {/* <FormGroup row sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckboxValue === "Success"}
                onChange={() => handleCheckboxChange("Success")}
              />
            }
            label="Success"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckboxValue === "Pending"}
                onChange={() => handleCheckboxChange("Pending")}
              />
            }
            label="Pending"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckboxValue === "Failed"}
                onChange={() => handleCheckboxChange("Failed")}
              />
            }
            label="Failed"
          />
        </FormGroup> */}

        <Box display="flex" justifyContent="center" mt={3}>
          <Button variant="contained" color="primary" sx={{ mr: 5 }}
            onClick={() => {
              SendDataToList();  // Parent me data set karo
              toggle_Filter();    // Modal close karo
            }}>
            Apply
          </Button>

          <Button variant="contained" color="error" onClick={toggle_Filter}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AFFilter;